<ng-container *ngIf="visible$ | async">

  <!-- Tiny restore pill when panel was dismissed -->
  <button
    *ngIf="hidden && !(isMimicking$ | async)"
    class="mimic-restore"
    (click)="show()"
    title="Show mimic panel">
    &#x1f50d;
  </button>

  <ng-container *ngIf="!hidden || (isMimicking$ | async)">

    <!-- Active mimic banner -->
    <div
      *ngIf="(isMimicking$ | async) && (mimicAddress$ | async) as addr"
      class="mimic-banner">

      <span class="mimic-label">MIMIC</span>
      <span class="mimic-address" [title]="addr">{{ truncate(addr) }}</span>

      <button class="mimic-btn change" (click)="toggle()">Change</button>
      <button class="mimic-btn exit" (click)="deactivate()">Exit</button>
    </div>

    <!-- Collapsed trigger (only when NOT mimicking) -->
    <div
      *ngIf="!(isMimicking$ | async) && !expanded"
      class="mimic-trigger-wrapper">
      <button
        class="mimic-trigger"
        (click)="toggle()"
        title="Mimic a wallet address">
        Mimic
      </button>
      <button
        class="mimic-dismiss"
        (click)="hide()"
        title="Hide mimic panel">
        &times;
      </button>
    </div>

    <!-- Expanded input panel -->
    <div *ngIf="expanded && !(isMimicking$ | async)" class="mimic-input-panel">
      <div class="mimic-input-header">
        <span>Mimic Wallet</span>
        <button class="mimic-close" (click)="toggle()">&times;</button>
      </div>

      <input
        type="text"
        [(ngModel)]="addressInput"
        placeholder="0x..."
        class="mimic-input"
        (keydown.enter)="activate()" />

      <div *ngIf="error" class="mimic-error">{{ error }}</div>

      <button class="mimic-btn activate" (click)="activate()">Activate</button>
    </div>

  </ng-container>

</ng-container>
